import React from "react";
import ajax from "./../lib/ajax.js";
import moment from 'moment';
import immutable from "immutable";
import context from "./../lib/context.js";
import AccrualSummary from "./accrual/accrual-summary.jsx";
import PtoList from "./pto/pto-list.jsx";

export default class PeopleAccrualHome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            accrualBalance: []
        }
        this.countGridLoading = 0;
        this.role = context.getRouteParam(this, "role");
        this.createOnInit = context.getRouteParam(this, "action") == "create",
        this.isAndroid = this.isAndroid.bind(this);
        this.isIos = this.isIos.bind(this);
        this.loadAccrualBalance = this.loadAccrualBalance.bind(this);
        this.onFilterAccrual = this.onFilterPto.bind(this);
        this.onFilterPto = this.onFilterPto.bind(this);
        this.onAccrualListLoaded = this.onAccrualListLoaded.bind(this);
        this.onPtoListInit = this.onPtoListInit.bind(this);
        this.onPtoListLoaded = this.onPtoListLoaded.bind(this);
        this.toggleLoadingDialog = this.toggleLoadingDialog.bind(this);
    }

    componentDidMount() {
        this.loadAccrualBalance();
    }

    loadAccrualBalance() {
        let self = this;
        self.toggleLoadingDialog(true);

        ajax.api()
            .get("get-accrual-balance/people")
            .then(res => {                
                const clone = immutable.fromJS(self.state).toJS();
                if (res.data != null && res.data.length > 0) 
                    clone.accrualBalance = res.data;
                    
                self.setState(clone, () => self.toggleLoadingDialog(false));
            }).catch(function (err) {
                let data = err.response? err.response.data : err;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onFilterAccrual() {
        this.toggleLoadingDialog(true);
    }

    onFilterPto() {
        this.toggleLoadingDialog(true);
    }

    onAccrualListLoaded() {
        this.toggleLoadingDialog(false);
    }

    onPtoListInit() {
        this.toggleLoadingDialog(true);
    }

    onPtoListLoaded() {
        this.toggleLoadingDialog(false);

        if (this.createOnInit) {
            this.createOnInit = false;
            this.refs.ptoList.openDetail(0, "create");
        }
    }

    toggleLoadingDialog(show) {
        this.countGridLoading += show? 1: -1;

        if (show) {
            context.message({
                show: true,
                type: "loading",
                message: "Loading. Please wait..."
            });
        }
        else if (this.countGridLoading <= 0) {
            context.message({ show: false });
            this.countGridLoading = 0;
        }
    }

    isAndroid() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1;
    }

    isIos() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('ipad') > - 1 || ua.indexOf('iphone') > -1;
    }

    render() {
        const isMobile = this.isIos() || this.isAndroid();
        let accrualBalance = this.state.accrualBalance;
        accrualBalance = accrualBalance.sort((a, b) => (a.accrualDescription < b.accrualDescription? -1: 1));
        
        let annivDate = "";
        let vacaBal = accrualBalance.filter(o => o.leaveGroup.includes('VACA'));
        if (vacaBal.length > 0) {
            annivDate = moment(vacaBal[0].leaveYearEndDate).add("d", 1).format("MMM D, YYYY");
        }

        return (
            <div className={isMobile? "container ap-accrual-mobile" : "container"}>
                {
                    isMobile?
                        <div className="row ap-mt-1">
                            <div className="col-xs-12 ap-text-right">
                                <button className="btn ap-pto-create-button" onClick={() => this.refs.ptoList.openDetail(0, "create")}>
                                    <i className="fa fa-send"></i>Request Time-Off
                                </button>
                            </div>
                            <div className="col-xs-12 ap-accrual-title">
                                Time-Off Activity
                            </div>
                            <div className="col-xs-12 ap-accrual-sub-title">
                                Anniversary Date: <b>{annivDate}</b>
                            </div>
                        </div>
                    :
                        <div className="row">
                            <div className="col-md-12 ap-accrual-title">
                                Time-Off Activity
                            </div>
                            <div className="col-md-4 col-md-offset-4 ap-accrual-sub-title">
                                Anniversary Date: <b>{annivDate}</b>
                            </div>
                            <div className="col-md-4 ap-pr-0 ap-py-1 ap-text-right">
                                <button className="btn ap-pto-create-button" onClick={() => this.refs.ptoList.openDetail(0, "create")}>
                                    <i className="fa fa-send"></i>Request Time-Off
                                </button>
                            </div>
                        </div>
                }
                <div className={isMobile? "row ap-px-1" : "row"}>
                    <PtoList userRole="people" title="Activity" onFilterChanged={this.onFilterPto} onInit={this.onPtoListInit} onLoad={this.onPtoListLoaded} onSaved={this.loadAccrualBalance} ref="ptoList" />
                </div>
                <div className="row">
                    <div className="col-xs-12 col-md-12">
                        &nbsp;
                    </div>
                </div>
                <div className={isMobile? "row ap-px-1" : "row"}>
                    <AccrualSummary userRole="people" title="Balance" accrualSummary={accrualBalance} createPto={(ptoType) => this.refs.ptoList.openDetail(0, "create", ptoType)} />
                </div>
            </div>
        );
    }
}
